const copyUrlBtn = document.querySelector("#copyUrlBtn");
const shareInput = document.querySelector("#shareUrlInput");

function copyUrl() {
    /* Select the text field */
    shareInput.select();
    shareInput.setSelectionRange(0, 99999); /* For mobile devices */
    /* Copy the text inside the text field */
    document.execCommand("copy");
    /* Log the copied text */
    // console.log("Copied the text: " + shareInput.value);
}

if (copyUrlBtn) {
    copyUrlBtn.addEventListener("click", function () {
        copyUrl();
    });
}
